__turbopack_context__.v({
  "icon": "agnt-text-icon-module-scss-module__Dj0R0a__icon",
  "link": "agnt-text-icon-module-scss-module__Dj0R0a__link",
  "toneBlue": "agnt-text-icon-module-scss-module__Dj0R0a__toneBlue",
  "toneNavy": "agnt-text-icon-module-scss-module__Dj0R0a__toneNavy",
});
